'use client'

import { useContext } from 'react'

import { AudioContext, type AudioContextType } from './audio-context'
import { safePlay } from './safe-play'

const noopContext: AudioContextType = {
  register: ({ id, audio, onUpdate }) => ({
    id,
    audio,
    onUpdate,
    toggle: () => {
      if (audio.paused) safePlay(audio)
      else audio.pause()
    },
  }),
  deregister: () => {},
}

export const useAudio = (): AudioContextType => {
  const context = useContext(AudioContext)
  return context ?? noopContext
}
